import React from 'react'
import fr from 'locales/fr.yaml'
import './styles.scss'

const localisationStrings = { fr }

export const AdminToolbar = ({
  locale,
  isConnected,
  username,
  profilePicture,
  adminViewOn,
  handleSignIn,
  handleSignOut,
  handleToggleAdminView
}: {
  locale: 'fr'
  isConnected: boolean
  username?: string
  profilePicture?: string
  adminViewOn: boolean
  handleSignIn: () => void
  handleSignOut: () => void
  handleToggleAdminView: () => void
}) => {
  return (
    <>
      {isConnected ? (
        <>
          <div className='admin-toolbar admin-connected row'>
            <div className='ui stackable one column grid'>
              <div className='right aligned column'>
                {profilePicture ? (
                  <img
                    className='admin-profile-picture'
                    referrerPolicy='no-referrer'
                    src={profilePicture + '?sz=50'}
                    title={username}
                  />
                ) : (
                  ''
                )}
                <span className='small'>{username}</span>
                <div className='right aligned ui basic buttons'>
                  <button className='ui button' onClick={handleToggleAdminView}>
                    {adminViewOn
                      ? localisationStrings[locale].userViewButton
                      : localisationStrings[locale].adminViewButton}
                  </button>
                  <button className='ui button' onClick={handleSignOut}>
                    {localisationStrings[locale].adminDisonnectButton}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </>
      ) : (
        <div className='admin-toolbar admin-disconnected right floated ui basic buttons'>
          <button className='ui button' onClick={handleSignIn}>
            {localisationStrings[locale].adminConnectButton}
          </button>
        </div>
      )}
    </>
  )
}
